<span class="level-badge" [ngClass]="colorClass()">
	@if (label()) {
		{{ label() }}
	}
	{{ level() }}<ng-content></ng-content>
</span>
